
// JS操作cookies方法!
// 写cookies
export function setCookie(name, value) {
  var Days = 300
  var exp = new Date()
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
  document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
}
// 读取cookies
export function getCookie(name) {
  var arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if (arr = document.cookie.match(reg)) {
      return unescape(arr[2])
  } else { return null }
}
// 删除cookies
export function delCookie(name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null) { document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() }
}

export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substring(1).match(reg)
  if (r != null) {
    return decodeURIComponent(r[2])
  }
  return null
}
export default {
  setCookie,
  getCookie,
  delCookie,
  getQueryString
}



// WEBPACK FOOTER //
// ./src/libs/utils/cookie.js